/* eslint-disable */
import React from 'react';
import MaskedInput from 'react-text-mask';

const MonthYearMask = (props: any) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        if (inputRef) {
          inputRef(ref ? ref.inputElement : null);
        }
      }}
      mask={[/[0-9]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      // placeholderChar={'\u2000'}
      // showMask
      placeholder="MM/YYYY"
      guide={false}
    />
  );
};

export default MonthYearMask;
